import _                               from 'underscore';
import React, { FC }                   from 'react';
import { Button, ButtonProps }         from 'semantic-ui-react';
import { Link, LinkProps, useHistory } from 'react-router-dom';

import { runIfFunction } from '../../util';

interface RouteButtonProps extends ButtonProps {
	to: string,
	
	onCondition?( to: string ): Promise<boolean> | boolean
}

const defaultProps = {
	to:          '/',
	onCondition: null,
}

const RouteButton: FC<RouteButtonProps> = ( _props ) => {
	
	let { to, onCondition, ...buttonProps } = _props,
	    history                             = useHistory();
	
	let handleConditional: ButtonProps['onClick'] = async ( e ) => {
		
		if( await onCondition( to ) ){
			
			runIfFunction( buttonProps.onClick, e );
			
			history.push( to );
		}
	}
	
	return (
		<>
			{ _.isFunction( onCondition ) ? (
				
				<Button { ...buttonProps } onClick={ handleConditional }/>
			
			) : (
				  <Link to={ to }>
					
					  <Button { ...buttonProps } />
				
				  </Link>
			  ) }
		</>
	);
};

RouteButton.defaultProps = defaultProps;

export { RouteButton }
